export const drawerItemsMain = [
  {
    key: "Operations Management",
    title: "operationsStatus",
    routes: [
      {
        nav: "OperationsManagement",
        routeName: "OperationsManagement",
        title: "operationsStatus",
      },
    ],
  },
  {
    key: "Add Operation",
    title: "addOperation",
    routes: [
      {
        nav: "PlaceOrder",
        routeName: "PlaceOrder",
        title: "addOperation",
      },
    ],
  },
];
